import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=c65f9214&scoped=true&"
import script from "./recycle.vue?vue&type=script&lang=js&"
export * from "./recycle.vue?vue&type=script&lang=js&"
import style0 from "./recycle.vue?vue&type=style&index=0&id=c65f9214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65f9214",
  null
  
)

export default component.exports